var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var PlaylistController = {
    /*****************************************************************************************************
        * Is using route "api/playlist/{groupid}" and http method "POST" to call the back-end.
    
        * @param {string} groupid
        * @param {PlaylistUploadDto} data
        * @param {File} media
        * @returns {PlaylistDownloadDto}
    ******************************************************************************************************/
    AddPlaylist: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("data", JSON.stringify(data.data));
        if (data.media)
            fd.append("media", data.media);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/{groupid}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    DeletePlaylist: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/assignment/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    RemoveAssignment: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/assignment/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {PlaylistUploadDto} data
        * @param {File} media
        * @returns {PlaylistDownloadDto}
    ******************************************************************************************************/
    UpdatePlaylistCompletely: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("data", JSON.stringify(data.data));
        if (data.media)
            fd.append("media", data.media);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/addContent/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {PlaylistContentUploadDto} data
        * @returns {PlaylistDownloadDto}
    ******************************************************************************************************/
    AddPlaylistContent: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/addContent/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.data
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/removeContent/{id}/{referenceId}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {string} referenceId
        * @returns {PlaylistDownloadDto}
    ******************************************************************************************************/
    RemovePlaylistContent: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/removeContent/{id}/{referenceId}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/updateContents/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {PlaylistContentUploadDto[]} contents
        * @returns {PlaylistDownloadDto}
    ******************************************************************************************************/
    UpdatePlaylistContents: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/updateContents/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/use/{playlistId}/{assignOptional}/{userId?}" and http method "POST" to call the back-end.
    
        * @param {string} playlistId
        * @param {boolean} assignOptional
        * @param {string} userId
        * @returns {void}
    ******************************************************************************************************/
    UsePlaylist: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/use/{playlistId}/{assignOptional}/{userId?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/done/{itemId}/{finishedReferenceId?}" and http method "POST" to call the back-end.
    
        * @param {string} itemId
        * @param {string} finishedReferenceId
        * @returns {void}
    ******************************************************************************************************/
    SetItemForPlaylists: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/done/{itemId}/{finishedReferenceId?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/states/updated" and http method "POST" to call the back-end.
    
        * @param {Date} when
        * @returns {boolean}
    ******************************************************************************************************/
    CheckForPlaylistStatesUpdate: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/states/updated", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.when
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/states/{full?}" and http method "POST" to call the back-end.
    
        * @param {boolean} full
        * @returns {ExtendedDataCollection<PlaylistStateDownloadDto, string>}
    ******************************************************************************************************/
    GetPlaylistStates: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/states/{full?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/state/reset/{playlistId}/{withEvents?}" and http method "POST" to call the back-end.
    
        * @param {string} playlistId
        * @param {boolean | null} withEvents
        * @returns {ExtendedDataCollection<PlaylistStateDownloadDto, string>}
    ******************************************************************************************************/
    ResetPlaylistState: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/state/reset/{playlistId}/{withEvents?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/globalJobRoles" and http method "GET" to call the back-end.
    
        * @returns {string[]}
    ******************************************************************************************************/
    GetGlobalJobRoles: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/globalJobRoles", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/definition/{playlistId}/{includeOld?}" and http method "GET" to call the back-end.
    
        * @param {string} playlistId
        * @param {boolean} includeOld
        * @returns {ExtendedDataCollection<PlaylistAssignmentDefinitionDownloadDto, UserShortInfoDownloadDto[]>}
    ******************************************************************************************************/
    GetPlaylistDefinitons: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/definition/{playlistId}/{includeOld?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/definition" and http method "POST" to call the back-end.
    
        * @param {PlaylistAssignmentDefinitionUploadDto} dto
        * @returns {PlaylistAssignmentDefinitionDownloadDto}
    ******************************************************************************************************/
    AddPlaylistDefinitons: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/definition", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.dto
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/definition/{id}" and http method "PATCH" to call the back-end.
    
        * @param {PlaylistAssignmentDefinitionUploadDto} dto
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    ChangePlaylistDefinitons: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/definition/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.dto
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/item/state/{itemId}" and http method "GET" to call the back-end.
    
        * @param {string} itemId
        * @returns {ExtendedDataCollection<PlaylistStateDownloadDto, PlaylistItemStateEnum>}
    ******************************************************************************************************/
    GetPlaylistItemState: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/item/state/{itemId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/isAssigned/{playlistId}" and http method "GET" to call the back-end.
    
        * @param {string} playlistId
        * @returns {boolean}
    ******************************************************************************************************/
    IsPlaylistAssigned: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/isAssigned/{playlistId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/assignPerDefinitions" and http method "POST" to call the back-end.
    
        * @returns {boolean}
    ******************************************************************************************************/
    AssignCurrentUserPerDefinitions: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/assignPerDefinitions", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/assignUsers/check/{playlistId}" and http method "POST" to call the back-end.
    
        * @param {string} playlistId
        * @param {UserImp[]} usersToImport
        * @returns {UserImp[]}
    ******************************************************************************************************/
    CheckUsersBeforeAssignment: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.usersToImport !== undefined)
            fd.append("usersToImport", JSON.stringify(data.usersToImport));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/assignUsers/check/{playlistId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/playlist/assignUsers/check/{playlistId}/{userId}" and http method "GET" to call the back-end.
    
        * @param {string} playlistId
        * @param {string} userId
        * @returns {boolean}
    ******************************************************************************************************/
    CheckUsersIsAssigned: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/assignUsers/check/{playlistId}/{userId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/assignUsers/import/{playlistId}" and http method "POST" to call the back-end.
    
        * @param {string} playlistId
        * @param {UserImp[]} usersToImport
        * @returns {void}
    ******************************************************************************************************/
    ImportUsersForAssignment: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.usersToImport !== undefined)
            fd.append("usersToImport", JSON.stringify(data.usersToImport));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/assignUsers/import/{playlistId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/assignedUsers/{playlistId}" and http method "POST" to call the back-end.
    
        * @param {string} playlistId
        * @param {TokenContainer} token
        * @returns {ExtendedDataCollection<PlaylistAssignedUser, PagingTokenContainer>}
    ******************************************************************************************************/
    GetAssignedUsers: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.token !== undefined)
            fd.append("token", JSON.stringify(data.token));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/assignedUsers/{playlistId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/getAssignmentData" and http method "GET" to call the back-end.
    
        * @returns {string[]}
    ******************************************************************************************************/
    GetAssignmentData: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/getAssignmentData", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/getAssignmentData/{what}" and http method "POST" to call the back-end.
    
        * @param {string} what
        * @param {TokenContainer} token
        * @returns {ExtendedDataCollection<KVP, string>}
    ******************************************************************************************************/
    GetAssignmentDataFor: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.token !== undefined)
            fd.append("token", JSON.stringify(data.token));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/getAssignmentData/{what}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/getTrainers/{id}/{take?}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {number | null} take
        * @param {TokenContainer} token
        * @returns {ExtendedDataCollection<UserShortInfoDownloadDto, PagingTokenContainer>}
    ******************************************************************************************************/
    GetTrainers: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.token !== undefined)
            fd.append("token", JSON.stringify(data.token));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/getTrainers/{id}/{take?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/addTrainers/{id}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {string[]} trainerIds
        * @returns {PlaylistDownloadDto}
    ******************************************************************************************************/
    AddTrainers: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("trainerIds", JSON.stringify(data.trainerIds));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/addTrainers/{id}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/removeTrainers/{id}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {string[]} trainerIds
        * @returns {PlaylistDownloadDto}
    ******************************************************************************************************/
    RemoveTrainers: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("trainerIds", JSON.stringify(data.trainerIds));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/removeTrainers/{id}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/actions/has/for/me" and http method "GET" to call the back-end.
    
        * @returns {boolean}
    ******************************************************************************************************/
    HasActions: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/actions/has/for/me", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/trainerDocs/has/for/me" and http method "GET" to call the back-end.
    
        * @returns {boolean}
    ******************************************************************************************************/
    HasTrainerDocs: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/trainerDocs/has/for/me", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/trainerDocs/for/me" and http method "GET" to call the back-end.
    
        * @returns {ExtendedDataCollection<PostDownloadDto, PlaylistDownloadDto[]>}
    ******************************************************************************************************/
    GetTrainerDocs: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/trainerDocs/for/me", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/actions/for/me" and http method "GET" to call the back-end.
    
        * @returns {PlaylistActionDto[]}
    ******************************************************************************************************/
    GetActions: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/actions/for/me", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/actions/for/me/node/{id}/{value?}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {number} value
        * @returns {void}
    ******************************************************************************************************/
    CloseNodeAction: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/actions/for/me/node/{id}/{value?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/actions/for/me/element/{id}/{value?}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {number} value
        * @returns {void}
    ******************************************************************************************************/
    CloseElementAction: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/actions/for/me/element/{id}/{value?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/check/if/user/has/access/{playlistId}/{lng?}" and http method "GET" to call the back-end.
    
        * @param {string} playlistId
        * @param {string} lng
        * @returns {boolean}
    ******************************************************************************************************/
    CheckIfUserHasAccess: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/check/if/user/has/access/{playlistId}/{lng?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/playlist/get/url/for/content/token/{playlistId}/{contentId}/{lng?}" and http method "GET" to call the back-end.
    
        * @param {string} playlistId
        * @param {string} contentId
        * @param {string} lng
        * @returns {boolean}
    ******************************************************************************************************/
    GetUrlForContentWithRouteToken: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/get/url/for/content/token/{playlistId}/{contentId}/{lng?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/get/url/for/content/{playlistId}/{contentId}/{lng?}" and http method "POST" to call the back-end.
    
        * @param {string} playlistId
        * @param {string} contentId
        * @param {string} lng
        * @returns {string}
    ******************************************************************************************************/
    GetUrlForContent: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/get/url/for/content/{playlistId}/{contentId}/{lng?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/get/url/for/trainerDocs/{playlistId}/{contentId}/{lng?}" and http method "POST" to call the back-end.
    
        * @param {string} playlistId
        * @param {string} contentId
        * @param {string} lng
        * @returns {string}
    ******************************************************************************************************/
    GetUrlForTrainerDocs: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/get/url/for/trainerDocs/{playlistId}/{contentId}/{lng?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/members/{playlistId}/roles" and http method "GET" to call the back-end.
    
        * @param {string} playlistId
        * @returns {ExtendedDataCollection<RoleAssignment, UserShortInfoDownloadDto[]>}
    ******************************************************************************************************/
    GetPlaylistMembersWithRoles: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/members/{playlistId}/roles", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/playlist/members/{playlistId}" and http method "POST" to call the back-end.
    
        * @param {string} playlistId
        * @param {RoleAssignment[]} assignments
        * @returns {UserDownloadDto[]}
    ******************************************************************************************************/
    AssignPlaylistRolesToUsers: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("assignments", JSON.stringify(data.assignments));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/members/{playlistId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=PlaylistController.js.map